module.exports = __webpack_public_path__ + "static/media/icon_suporte.513e466c.svg";